import { render } from "./EmailComponent.vue?vue&type=template&id=48048832&scoped=true"
import script from "./EmailComponent.vue?vue&type=script&lang=js"
export * from "./EmailComponent.vue?vue&type=script&lang=js"

import "./EmailComponent.vue?vue&type=style&index=0&id=48048832&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48048832"]])

export default __exports__